import { roundToScale } from '@/shared'

export const roundRands = <T extends number|null|undefined>(value: T) => roundToScale(value, 4)
